import { APIS } from '../../config/apis';
import { ALERT_TYPE, IDS, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest, ServerRequestAsync } from '../../utils/apiweb';
import { CloneObject, cloneEntityInit } from '../../utils/helpers';

// DTO inicial del alta (fuente única: lo usan la vista de detalle y el alta directa de la grilla)
const INMUEBLE_ENTITY_INIT = {
    inmueble: {
        id: 0,
        idCuenta: 0,
        idEstadoCarga: 20,
        fechaCargaInicio: null,
        fechaCargaFin: null,
        catastralCir: '',
        catastralSec: '',
        catastralChacra: '',
        catastralLchacra: '',
        catastralQuinta: '',
        catastralLquinta: '',
        catastralFrac: '',
        catastralLfrac: '',
        catastralManz: '',
        catastralLmanz: '',
        catastralParc: '',
        catastralLparc: '',
        catastralSubparc: '',
        catastralUfunc: '',
        catastralUcomp: '',
        catastralRtasPrv: '',
        tributoManz: '',
        tributoLote: '',
        tributoEsquina: false,
        catastralCodigo: '',
        catastralPartido: ''
    },
    cuenta: {
        id: 0,
        numeroCuenta: '',
        numeroWeb: '',
        idEstadoCuenta: 1,
        idTipoTributo: 0,
        idTributo: 0,
        fechaAlta: null,
        fechaBaja: null
    },
    relacionesCuentas: [],
    archivos: [],
    observaciones: [],
    etiquetas: [],
    variablesCuenta: [],
    ladosTerreno: [],
    vinculosInmueble: [],
    zonasEntrega: [],
    controladoresCuentas: [],
    valuaciones: [],
    obrasInmueble: [],
    condicionesEspeciales: [],
    superficies: [],
    edesur: [],
    recargosDescuentos: [],
    debitosAutomaticos: []
};

// Factory: cada consumidor recibe su propio clon, así nadie muta el DTO compartido
export const buildInmuebleEntityInit = () => cloneEntityInit(INMUEBLE_ENTITY_INIT);

export const UpdateEntityRow = (typeEntity, row, entity) => {
    // o:original a:add m:modify r:remove c:modify only childs

    if (typeEntity === 'RelacionCuenta') {
        if (row.state === 'a') {
            entity.relacionesCuentas.push(row);
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.relacionesCuentas = entity.relacionesCuentas.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.relacionesCuentas.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'LadoTerreno') {
        if (row.state === 'a') {
            entity.ladosTerreno.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.ladosTerreno.indexOf(entity.ladosTerreno.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.ladosTerreno[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.ladosTerreno = entity.ladosTerreno.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.ladosTerreno.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'LadoTerrenoServicio') {
        let ladoTerreno = entity.ladosTerreno.find(x => x.id === row.idLadoTerreno);
        if (ladoTerreno.state === 'o') {
            ladoTerreno.state = 'c';
        }

        if (row.state === 'a') {
            ladoTerreno.ladosTerrenoServicio.push(row);
        }
        else if (row.state === 'm') {
            const index = ladoTerreno.ladosTerrenoServicio.indexOf(ladoTerreno.ladosTerrenoServicio.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //sigue siendo un alta porque no existe en la bd
                ladoTerreno.ladosTerrenoServicio[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                ladoTerreno.ladosTerrenoServicio = ladoTerreno.ladosTerrenoServicio.filter(f => f.id !== row.id);
            }
            else {
                let item = ladoTerreno.ladosTerrenoServicio.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'LadoTerrenoObra') {
        let ladoTerreno = entity.ladosTerreno.find(x => x.id === row.idLadoTerreno);
        if (ladoTerreno.state === 'o') {
            ladoTerreno.state = 'c';
        }

        if (row.state === 'a') {
            ladoTerreno.ladosTerrenoObra.push(row);
        }
        else if (row.state === 'm') {
            const index = ladoTerreno.ladosTerrenoObra.indexOf(ladoTerreno.ladosTerrenoObra.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //sigue siendo un alta porque no existe en la bd
                ladoTerreno.ladosTerrenoObra[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                ladoTerreno.ladosTerrenoObra = ladoTerreno.ladosTerrenoObra.filter(f => f.id !== row.id);
            }
            else {
                let item = ladoTerreno.ladosTerrenoObra.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'VariableCuenta') {
        if (row.state === 'a') {
            entity.variablesCuenta.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.variablesCuenta.indexOf(entity.variablesCuenta.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.variablesCuenta[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.variablesCuenta = entity.variablesCuenta.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.variablesCuenta.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'VinculoInmueble') {
        if (row.state === 'a') {
            entity.vinculosInmueble.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.vinculosInmueble.indexOf(entity.vinculosInmueble.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.vinculosInmueble[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.vinculosInmueble = entity.vinculosInmueble.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.vinculosInmueble.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ZonaEntrega') {
        if (row.state === 'a') {
            entity.zonasEntrega.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.zonasEntrega.indexOf(entity.zonasEntrega.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.zonasEntrega[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.zonasEntrega = entity.zonasEntrega.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.zonasEntrega.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ControladorCuenta') {
        if (row.state === 'a') {
            entity.controladoresCuentas.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.controladoresCuentas.indexOf(entity.controladoresCuentas.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.controladoresCuentas[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.controladoresCuentas = entity.controladoresCuentas.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.controladoresCuentas.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Valuacion') {
        if (row.state === 'a') {
            entity.valuaciones.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.valuaciones.indexOf(entity.valuaciones.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.valuaciones[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.valuaciones = entity.valuaciones.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.valuaciones.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ObraInmueble') {
        if (row.state === 'a') {
            entity.obrasInmueble.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.obrasInmueble.indexOf(entity.obrasInmueble.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.obrasInmueble[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.obrasInmueble = entity.obrasInmueble.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.obrasInmueble.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ObraInmuebleDetalle') {
        let obraInmueble = entity.obrasInmueble.find(x => x.id === row.idObraInmueble);
        if (obraInmueble.state === 'o') {
            obraInmueble.state = 'c';
        }

        if (row.state === 'a') {
            obraInmueble.obrasInmuebleDetalle.push(row);
        }
        else if (row.state === 'm') {
            const index = obraInmueble.obrasInmuebleDetalle.indexOf(obraInmueble.obrasInmuebleDetalle.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //sigue siendo un alta porque no existe en la bd
                obraInmueble.obrasInmuebleDetalle[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                obraInmueble.obrasInmuebleDetalle = obraInmueble.obrasInmuebleDetalle.filter(f => f.id !== row.id);
            }
            else {
                let item = obraInmueble.obrasInmuebleDetalle.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'CondicionEspecial') {
        if (row.state === 'a') {
            entity.condicionesEspeciales.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.condicionesEspeciales.indexOf(entity.condicionesEspeciales.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.condicionesEspeciales[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.condicionesEspeciales = entity.condicionesEspeciales.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.condicionesEspeciales.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Superficie') {
        if (row.state === 'a') {
            entity.superficies.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.superficies.indexOf(entity.superficies.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.superficies[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.superficies = entity.superficies.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.superficies.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Edesur') {
        if (row.state === 'a') {
            entity.edesur.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.edesur.indexOf(entity.edesur.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a';
                entity.edesur[index] = row;
            }
        }
        else if (row.state === 'r') {
            let item = entity.edesur.find(x => x.id === row.id);
            item.state = 'r';
        }
    }

    if (typeEntity === 'EdesurCliente') {
        let edesur = entity.edesur.find(x => x.id === row.idEdesur);
        if (edesur.state === 'o') {
            edesur.state = 'c';
        }

        if (row.state === 'a') {
            edesur.edesurClientes.push(row);
        }
        else if (row.state === 'm') {
            const index = edesur.edesurClientes.indexOf(edesur.edesurClientes.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //sigue siendo un alta porque no existe en la bd
                edesur.edesurClientes[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                edesur.edesurClientes = edesur.edesurClientes.filter(f => f.id !== row.id);
            }
            else {
                let item = edesur.edesurClientes.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'RecargoDescuento') {
        if (row.state === 'a') {
            entity.recargosDescuentos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.recargosDescuentos.indexOf(entity.recargosDescuentos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.recargosDescuentos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.recargosDescuentos = entity.recargosDescuentos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.recargosDescuentos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'DebitosAutomaticos') {
        if (row.state === 'a') {
            entity.debitosAutomaticos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.debitosAutomaticos.indexOf(entity.debitosAutomaticos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.debitosAutomaticos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.debitosAutomaticos = entity.debitosAutomaticos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.debitosAutomaticos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

}

export const FindInmueble = (state, setState, callbackNoSuccess, callbackError, callbackSuccessFindInmueble) => {

    setState(prevState => {
        return { ...prevState, loading: true };
    });

    const paramsUrl = `/${state.id}`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.INMUEBLE,
        paramsUrl,
        null,
        callbackSuccessFindInmueble,
        callbackNoSuccess,
        callbackError
    );

}

export const AddInmueble = (state, setState, inmueble_formValues, cuenta_formValues, dispatch, navigate, dataTaggerActionClear, callbackNoSuccess, callbackError) => {

    setState(prevState => {
        return { ...prevState, loading: true };
    });

    const callbackSuccess = (response) => {
        response.json()
            .then((row) => {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Inmueble ingresado correctamente", () => {
                    dispatch(dataTaggerActionClear(state.processKey));
                    setState(prevState => {
                        return { ...prevState, loading: false };
                    });
                    navigate({
                        to: `/inmueble/${OPERATION_MODE.EDIT}/${row.inmueble.id}`,
                        refresh: true,
                        replace: true,
                    })
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return { ...prevState, loading: false };
                });
            });
    };

    const dataBody = {
        inmueble: {
            ...state.entity.inmueble,
            idEstadoCarga: inmueble_formValues.idEstadoCarga,
            catastralCir: inmueble_formValues.catastralCir.trim(),
            catastralSec: inmueble_formValues.catastralSec.trim(),
            catastralChacra: inmueble_formValues.catastralChacra.trim(),
            catastralLchacra: inmueble_formValues.catastralLchacra.trim(),
            catastralQuinta: inmueble_formValues.catastralQuinta.trim(),
            catastralLquinta: inmueble_formValues.catastralLquinta.trim(),
            catastralFrac: inmueble_formValues.catastralFrac.trim(),
            catastralLfrac: inmueble_formValues.catastralLfrac.trim(),
            catastralManz: inmueble_formValues.catastralManz.trim(),
            catastralLmanz: inmueble_formValues.catastralLmanz.trim(),
            catastralParc: inmueble_formValues.catastralParc.trim(),
            catastralLparc: inmueble_formValues.catastralLparc.trim(),
            catastralSubparc: inmueble_formValues.catastralSubparc.trim(),
            catastralUfunc: inmueble_formValues.catastralUfunc.trim(),
            catastralUcomp: inmueble_formValues.catastralUcomp.trim(),
            catastralRtasPrv: inmueble_formValues.catastralRtasPrv.trim(),
            tributoManz: inmueble_formValues.tributoManz.trim(),
            tributoLote: inmueble_formValues.tributoLote.trim(),
            tributoEsquina: inmueble_formValues.tributoEsquina,
            catastralCodigo: inmueble_formValues.catastralCodigo.trim(),
            catastralPartido: inmueble_formValues.catastralPartido.trim()
        },
        cuenta: {
            ...state.entity.cuenta,
            numeroCuenta: cuenta_formValues.numeroCuenta,
            numeroWeb: cuenta_formValues.numeroWeb
        },
        relacionesCuentas: [],
        archivos: [],
        observaciones: [],
        etiquetas: [],
        variablesCuenta: [],
        ladosTerreno: [],
        vinculosInmueble: [],
        zonasEntrega: [],
        controladoresCuentas: [],
        valuaciones: [],
        obrasInmueble: [],
        condicionesEspeciales: [],
        superficies: [],
        edesur: [],
        recargosDescuentos: [],
        debitosAutomaticos: []
    };

    ServerRequest(
        REQUEST_METHOD.POST,
        null,
        true,
        APIS.URLS.INMUEBLE,
        null,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const ModifyInmueble = (state, setState, dataTagger, inmueble_formValues, cuenta_formValues, dispatch, dataTaggerActionClear, callbackNoSuccess, callbackError, callbackSuccessFindInmueble) => {

    setState(prevState => {
        return { ...prevState, loading: true };
    });

    const callbackSuccess = (response) => {
        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Inmueble actualizado correctamente", () => {
            dispatch(dataTaggerActionClear(state.processKey));
            callbackSuccessFindInmueble(response);
        });
    };

    const dataBody = {
        inmueble: {
            ...state.entity.inmueble,
            idEstadoCarga: inmueble_formValues.idEstadoCarga,
            catastralCir: inmueble_formValues.catastralCir.trim(),
            catastralSec: inmueble_formValues.catastralSec.trim(),
            catastralChacra: inmueble_formValues.catastralChacra.trim(),
            catastralLchacra: inmueble_formValues.catastralLchacra.trim(),
            catastralQuinta: inmueble_formValues.catastralQuinta.trim(),
            catastralLquinta: inmueble_formValues.catastralLquinta.trim(),
            catastralFrac: inmueble_formValues.catastralFrac.trim(),
            catastralLfrac: inmueble_formValues.catastralLfrac.trim(),
            catastralManz: inmueble_formValues.catastralManz.trim(),
            catastralLmanz: inmueble_formValues.catastralLmanz.trim(),
            catastralParc: inmueble_formValues.catastralParc.trim(),
            catastralLparc: inmueble_formValues.catastralLparc.trim(),
            catastralSubparc: inmueble_formValues.catastralSubparc.trim(),
            catastralUfunc: inmueble_formValues.catastralUfunc.trim(),
            catastralUcomp: inmueble_formValues.catastralUcomp.trim(),
            catastralRtasPrv: inmueble_formValues.catastralRtasPrv.trim(),
            tributoManz: inmueble_formValues.tributoManz.trim(),
            tributoLote: inmueble_formValues.tributoLote.trim(),
            tributoEsquina: inmueble_formValues.tributoEsquina,
            catastralCodigo: inmueble_formValues.catastralCodigo.trim(),
            catastralPartido: inmueble_formValues.catastralPartido.trim()
        },
        cuenta: {
            ...state.entity.cuenta,
            numeroCuenta: cuenta_formValues.numeroCuenta,
            numeroWeb: cuenta_formValues.numeroWeb
        },
        relacionesCuentas: state.entity.relacionesCuentas.filter(f => f.state !== 'o'),
        archivos: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Archivo.filter(f => f.state !== 'o') : [],
        observaciones: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Observacion.filter(f => f.state !== 'o') : [],
        etiquetas: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Etiqueta.filter(f => f.state !== 'o') : [],
        variablesCuenta: state.entity.variablesCuenta, //en este caso hacen falta todos para validar los rangos
        ladosTerreno: state.entity.ladosTerreno.filter(f => f.state !== 'o').map(y => {
            let x = CloneObject(y);
            x.ladosTerrenoServicio = x.ladosTerrenoServicio.filter(f => f.state !== 'o');
            x.ladosTerrenoObra = x.ladosTerrenoObra.filter(f => f.state !== 'o');
            return x;
        }),
        vinculosInmueble: state.entity.vinculosInmueble, //en este caso hacen falta todos para calcular el referente de la cuenta
        zonasEntrega: state.entity.zonasEntrega.filter(f => f.state !== 'o'),
        controladoresCuentas: state.entity.controladoresCuentas.filter(f => f.state !== 'o'),
        valuaciones: state.entity.valuaciones.filter(f => f.state !== 'o'),
        obrasInmueble: state.entity.obrasInmueble.filter(f => f.state !== 'o').map(y => {
            let x = CloneObject(y);
            x.obrasInmuebleDetalle = x.obrasInmuebleDetalle.filter(f => f.state !== 'o');
            return x;
        }),
        condicionesEspeciales: state.entity.condicionesEspeciales.filter(f => f.state !== 'o'),
        superficies: state.entity.superficies.filter(f => f.state !== 'o'),
        edesur: state.entity.edesur.filter(f => f.state !== 'o').map(y => {
            let x = CloneObject(y);
            x.edesurClientes = x.edesurClientes.filter(f => f.state !== 'o');
            return x;
        }),
        recargosDescuentos: state.entity.recargosDescuentos.filter(f => f.state !== 'o'),
        debitosAutomaticos: state.entity.debitosAutomaticos.filter(f => f.state !== 'o')
    };

    const paramsUrl = `/${state.id}`;

    ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.INMUEBLE,
        paramsUrl,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const ModifyBajaCuenta = (idCuenta, state, setState, dispatch, navigate, dataTaggerActionClear, callbackNoSuccess, callbackError) => {

    setState(prevState => {
        return { ...prevState, loading: true };
    });

    const callbackSuccess = (response) => {
        response.json()
            .then((row) => {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La cuenta fue dada de baja correctamente", () => {
                    dispatch(dataTaggerActionClear(state.processKey));
                    setState(prevState => {
                        return { ...prevState, loading: false };
                    });
                    navigate({
                        to: `/inmueble/${OPERATION_MODE.VIEW}/${row.idTributo}`,
                        refresh: true,
                        replace: true,
                    })
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return { ...prevState, loading: false };
                });
            });
    };

    const paramsUrl = `/baja/${idCuenta}`;

    ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.CUENTA,
        paramsUrl,
        null,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const MakeListDomicilios = async (state) => {
    return new Promise(async (resolve, reject) => {
        try {
            let listDomicilios = [];

            if (state.entity.ladosTerreno.length > 0 && state.entity.cuenta.idDireccionPrincipal) {
                let direccion = null;
                state.entity.ladosTerreno.forEach(x => {
                    if (x.direccion.id === state.entity.cuenta.idDireccionPrincipal) {
                        direccion = x.direccion;
                    }
                });
                if (direccion) {
                    const domicilioInmueble = {...direccion, domicilio: "Inmueble"};
                    listDomicilios.push(domicilioInmueble);
                }
            }
            if (state.entity.zonasEntrega.length > 0 && state.entity.cuenta.idDireccionEntrega) {
                let direccion = null;
                state.entity.zonasEntrega.forEach(x => {
                    if (x.direccion.id === state.entity.cuenta.idDireccionEntrega) {
                        direccion = x.direccion;
                    }
                });
                if (direccion) {
                    const domicilioEntrega = {...direccion, domicilio: "Entrega"};
                    listDomicilios.push(domicilioEntrega);
                }
            }

            const titular = state.entity.vinculosInmueble.find(vinculo => vinculo.idTipoVinculoInmueble === IDS.TIPO_VINCULO_INMUEBLE.TITULAR)
            if (titular) {
                let direccion = null;

                const isPersonaFisica = (titular.idTipoPersona === IDS.TIPO_PERSONA.FISICA);
                const endpoint = isPersonaFisica ? APIS.URLS.PERSONA_FISICA : APIS.URLS.PERSONA_JURIDICA;
                const paramsUrl = `/${titular.idPersona}`;

                try {
                    const res = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, endpoint, paramsUrl);
                    if (res.ok) {
                        try {
                            const data = await res.json();
                            direccion = isPersonaFisica ? data.direccion : data.domicilioLegal;
                        }
                        catch (error) {
                            reject(error);
                            return;
                        }
                    }
                    else {
                        reject(res);
                        return;
                    }
                }
                catch(error) {
                    reject(error);
                    return;
                }

                if (direccion) {
                    const domicilioTitular = {...direccion, domicilio: "Titular"};
                    listDomicilios.push(domicilioTitular);
                }
            }

            resolve(listDomicilios);
        }
        catch (error) {
            reject(error);
        }
    });
}


export function MakeListDomiciliosRelacionados(vinculosTributo, ladosTerreno) {
    return new Promise(async (resolve, reject) => {
        try {
            let listDomicilios = [];

            ladosTerreno.forEach(ladosTerreno => {
                if(ladosTerreno.idTipoLado === IDS.TIPO_LADO.FRENTE) {
                    const domicilio = { ...ladosTerreno.direccion, tipoVinculo: 'Dirección Real', nombrePersona: '' };
                    listDomicilios.push(domicilio);
                }
            });

            const promises = vinculosTributo.map(async (vinculo) => {
                if (vinculo.idTipoVinculoInmueble === IDS.TIPO_VINCULO_INMUEBLE.TITULAR || 
                    vinculo.idTipoVinculoInmueble === IDS.TIPO_VINCULO_INMUEBLE.RESPONSABLE_CUENTA) {
                    const isPersonaFisica = (vinculo.idTipoPersona === IDS.TIPO_PERSONA.FISICA);
                    const endpoint = isPersonaFisica ? APIS.URLS.PERSONA_FISICA : APIS.URLS.PERSONA_JURIDICA;
                    const paramsUrl = `/${vinculo.idPersona}`;

                    try {
                        const response = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, endpoint, paramsUrl);
                        if (response.ok) {
                            const data = await response.json();
                            const direccion = isPersonaFisica ? data.direccion : data.domicilioLegal;
                            const tipoVinculo = vinculo.idTipoVinculoInmueble === IDS.TIPO_VINCULO_INMUEBLE.TITULAR ? 'Titular' : "Responsable de cuenta";
                            const domicilio = { ...direccion, tipoVinculo: tipoVinculo, nombrePersona: vinculo.nombrePersona };
                            return domicilio;
                        }
                    } catch (error) {
                        reject(error);
                    }
                }
            });

            const results = await Promise.all(promises);

            results.forEach(domicilio => {
                if (domicilio) {
                    listDomicilios.push(domicilio);
                }
            });

            resolve(listDomicilios);
        } catch (error) {
            reject(error);
        }
    });
  }